const styles = theme => ({
  title: {
    color: theme.qlikGreen,
    fontWeight: 'normal',
    fontSize: theme.fontSize * 1.5,
    marginBottom: 0,
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    boxSizing: 'border-box',
    border: '2px solid #009845',
    borderRadius: '30px',
    padding: '0 18px',
    fontSize: '1em',
    lineHeight: '1em',
    color: '#FFFFFF',
    fontWeight: 'bold',
    textDecoration: 'none',
    transition: 'all .25s ease-in-out',
    backgroundColor: '#009845',
    cursor: 'pointer',
    height: '40px',
    width: '136px',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#009845',
    },
  },
  currencySelectMenu: {
    position: 'absolute',
    background: 'white',
    zIndex: 1,
    height: 200,
    overflowY: 'auto',
    overflowX: 'hidden',
    border: '1px solid black',
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  currencySelectOption: {
    cursor: 'pointer',
  },
  filterContainer: {
    width: 286,
  },
  btnFilled: theme.btnFilled,
});


export default styles;
